<template>
  <router-view />
</template>

<script>
export default {
  name: 'Timesheets'
};
</script>

<style lang="scss" scoped></style>
